var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 12.5L10 10M11.6667 8.33333L12.5 7.5M9.16667 5L9.5525 4.55333C10.334 3.77194 11.3939 3.333 12.499 3.33308C13.6042 3.33316 14.664 3.77225 15.4454 4.55375C16.2268 5.33525 16.6657 6.39516 16.6657 7.5003C16.6656 8.60543 16.2265 9.66527 15.445 10.4467L15 10.8333M2.5 2.5L17.5 17.5M10.8333 15L10.5025 15.445C9.71189 16.2268 8.64484 16.6653 7.53293 16.6653C6.42103 16.6653 5.35398 16.2268 4.56335 15.445C4.17365 15.0597 3.86426 14.6008 3.65311 14.0951C3.44196 13.5894 3.33323 13.0468 3.33323 12.4987C3.33323 11.9507 3.44196 11.4081 3.65311 10.9024C3.86426 10.3966 4.17365 9.93783 4.56335 9.5525L5.00002 9.16667",
    stroke: "#3A3D40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptOut);
export default __webpack_public_path__ + "static/media/opt-out.be4235feb67aa8e05fe83bd015f101d2.svg";
export { ForwardRef as ReactComponent };